// src/pages/TherapistReferralsPage.js
import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { collection, query, where, getDocs, orderBy } from 'firebase/firestore'
import { db } from '../firebaseConfig'

export default function TherapistReferralsPage() {
  const [params] = useSearchParams()
  const idNumber = params.get('idNumber') // id_number upline
  const therapistUid = params.get('id') // UID (doc id)

  const [loading, setLoading] = useState(true)
  const [referrals, setReferrals] = useState([])

  useEffect(() => {
    if (!idNumber) return
    loadReferrals()
  }, [idNumber])

  const loadReferrals = async () => {
    setLoading(true)

    const q = query(
      collection(db, 'referrals'),
      where('referredByIdNumber', '==', idNumber),
      orderBy('joinedAt', 'desc')
    )

    const snap = await getDocs(q)
    const list = snap.docs.map((d) => ({
      id: d.id,
      ...d.data(),
    }))

    setReferrals(list)
    setLoading(false)
  }

  return (
    <div className="min-h-screen bg-gray-950 text-gray-200 p-6">
      <h2 className="text-xl font-bold mb-4">Referral Terapis ({idNumber})</h2>

      {loading ? (
        <p className="text-gray-400">Memuat data referral...</p>
      ) : referrals.length === 0 ? (
        <p className="text-gray-500">Belum ada referral.</p>
      ) : (
        <div className="bg-gray-900 border border-gray-800 rounded-lg p-4">
          {referrals.map((r) => (
            <div
              key={r.id}
              className="border-b border-gray-800 pb-3 mb-3 last:border-none"
            >
              <div className="flex justify-between items-center">
                <div>
                  <p className="font-semibold text-white">
                    {r.referredMitraName}
                  </p>
                  <p className="text-gray-400 text-sm">
                    ID: {r.referredMitraId}
                  </p>
                  <p className="text-gray-500 text-xs mt-1">
                    Bergabung: {r.joinedAt?.toDate().toLocaleString('id-ID')}
                  </p>
                </div>

                <span
                  className={`px-2 py-1 rounded text-xs ${
                    r.status === 'active'
                      ? 'bg-green-800/40 text-green-300'
                      : 'bg-red-800/40 text-red-300'
                  }`}
                >
                  {r.status}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
